import React, { useContext, useRef } from "react";

import { Headline } from "../../components/Headline";
import { SectionContainer } from "../../components/SectionContainer";
import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";
import { Tagline } from "../../components/Tagline/Tagline";
import HeroLayoutElement from "./HeroLayoutElement";

import { generateClassString as gcs } from "../../lib/helper/generateClassString";
import ElementContext from "../../components/ElementContext";

import * as styles from "./component.module.less";

function HeroMediaText({
    data: {
        ctaButton,
        secundarButton,
        tagline,
        semanticOfHeadline,
        headline,
        subheadline,
        mediaBlock,
        background,
        mediaLayout,
        galleryAssets,
        thumbnails
    },
    type
}) {
    const { isLightBg } = useContext(ElementContext);

    return (
        <SectionContainer
            containerClass={styles.container}
            reducedWidth="never"
            background={background}
        >
            <div
                className={gcs(
                    styles.heroMediaTextBlock,
                    [
                        mediaLayout === "standard_with_slider" ||
                            mediaLayout === "big_picture",
                        styles.noSliderBlock
                    ],
                    [
                        mediaLayout === "big_picture",
                        styles.heroMediaTextBlockBigPicture
                    ]
                )}
            >
                <div>
                    <Tagline hasLightBackground={isLightBg}>{tagline}</Tagline>

                    <Headline
                        semanticOfHeadline={semanticOfHeadline}
                        hasLightBackground={isLightBg}
                    >
                        {headline}
                    </Headline>

                    <StructuredTextRenderer data={subheadline} />
                    <div className={styles.buttonContainer}>
                        <StructuredTextRenderer
                            data={ctaButton}
                            itemLinkType={"cta"}
                            contentElementType={type}
                        />

                        <StructuredTextRenderer
                            itemLinkType={"secondary"}
                            data={secundarButton}
                            contentElementType={type}
                            itemLinkIcon="arrowRight"
                            itemLinkIconPosition="right"
                            itemLinkClass={!isLightBg ? styles.lightColor : ""}
                        />
                    </div>
                </div>
                <HeroLayoutElement
                    mediaBlock={mediaBlock}
                    mediaLayout={mediaLayout}
                    galleryAssets={galleryAssets}
                    thumbnails={thumbnails}
                />
            </div>
        </SectionContainer>
    );
}

export { HeroMediaText };
